import React from "react";
import { Trash2 } from "lucide-react";

/**
 * A card component for displaying and editing award tier information
 */
export function AwardTierCard({
  award,
  isPercentageBased,
  maxPossibleValue,
  onChange,
  onRemove
}) {
  return (
    <div className="card bg-base-200 border border-base-300 hover:shadow-sm transition-all">
      <div className="card-body p-4">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-4">
            <input
              type="color"
              value={award.color}
              onChange={(e) => onChange(award.id, 'color', e.target.value)}
              className="w-8 h-8 rounded cursor-pointer"
            />
            <input
              type="text"
              value={award.name}
              onChange={(e) => onChange(award.id, 'name', e.target.value)}
              placeholder="Award Name (e.g., Platinum)"
              className="input input-bordered input-sm flex-1"
            />
            <button
              onClick={() => onRemove(award.id)}
              className="btn btn-ghost btn-sm btn-square text-error"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex-1 grid grid-cols-2 gap-4">
              <div>
                <label className="label text-sm">Max Score</label>
                <input
                  type="number"
                  value={award.maxScore}
                  onChange={(e) => onChange(award.id, 'maxScore', parseFloat(e.target.value))}
                  className="input input-bordered input-sm w-full"
                  step={isPercentageBased ? "0.1" : "1"}
                  max={isPercentageBased ? 100 : maxPossibleValue}
                />
              </div>
              <div>
                <label className="label text-sm">Min Score</label>
                <input
                  type="number"
                  value={award.minScore}
                  onChange={(e) => onChange(award.id, 'minScore', parseFloat(e.target.value))}
                  className="input input-bordered input-sm w-full"
                  step={isPercentageBased ? "0.1" : "1"}
                  max={award.maxScore}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 